
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import ContentNavigation from '../common/ContentNavigation';

import LoginInfo from '../auth/LoginInfo';

const classNames = mergeStyleSets({
    appNavigation: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 16,
        marginBottom: 8,
        borderBottom: '1px solid #cccccc'
    },
});

const NAVIGATION_ITEMS = {
    home: {title: 'Úvodní strana', path: '#/'},
    projectList: {title: 'Seznam projektů', path: '#/projectList'},
    projectView: {title: '@PROJECT_TITLE@', path: '#/projectview/@PROJECT_ID@'},
    analyze2opsub: {title: 'Analýza dvou vlastníků', path: '#/analyze2opsub/@PROJECT_ID@'},
    analyzeDefunctPar: {title: 'Analýza zaniklých parcel', path: '#/analyzeDefunctPar/@PROJECT_ID@'},
    analyzeVla: {title: 'Analýza vlastnictví', path: '#/analyzeVla/@PROJECT_ID@'},
    isknExplorer: {title: 'KN průzkumník', path: '#/isknExplorer/@PROJECT_ID@'},
    isknActualInfo: {title: 'Datové sady ISKN z wH', path: '#/isknActualInfo/@PROJECT_ID@'}
};

const NAVIGATION_ITEMS_FOR_PAGE = {
    home: {items: [NAVIGATION_ITEMS.home]},
    projectList: {items: [NAVIGATION_ITEMS.home, NAVIGATION_ITEMS.projectList]},
    projectView: {items: [NAVIGATION_ITEMS.home, NAVIGATION_ITEMS.projectList, NAVIGATION_ITEMS.projectView]},
    analyzeVla: {items: [NAVIGATION_ITEMS.home, NAVIGATION_ITEMS.projectList, NAVIGATION_ITEMS.projectView, NAVIGATION_ITEMS.analyzeVla]},
    analyze2opsub: {items: [NAVIGATION_ITEMS.home, NAVIGATION_ITEMS.projectList, NAVIGATION_ITEMS.projectView, NAVIGATION_ITEMS.analyze2opsub]},
    analyzeDefunctPar: {items: [NAVIGATION_ITEMS.home, NAVIGATION_ITEMS.projectList, NAVIGATION_ITEMS.projectView, NAVIGATION_ITEMS.analyzeDefunctPar]},
    isknExplorer: {items: [NAVIGATION_ITEMS.home, NAVIGATION_ITEMS.projectList, NAVIGATION_ITEMS.projectView, NAVIGATION_ITEMS.isknExplorer]},
    isknActualInfo: {items: [NAVIGATION_ITEMS.home, NAVIGATION_ITEMS.projectList, NAVIGATION_ITEMS.projectView, NAVIGATION_ITEMS.isknActualInfo]}
};

const AppNavigation = ({pageId, project}) => {

    const processTemplate = (template) => {
        let text = template;
        text = text.replace('@PROJECT_TITLE@', project.title);
        text = text.replace('@PROJECT_ID@', project.id);
        return text;
    }

    const getNavigationItems = () => {
        let items = NAVIGATION_ITEMS_FOR_PAGE[pageId].items;

        return items.map(item => {
            return {
                title: processTemplate(item.title),
                path: processTemplate(item.path)
            }
        });
    }

    return (
        <Stack horizontal className={classNames.appNavigation}>
            <Stack.Item grow>
                <ContentNavigation
                    items={getNavigationItems()}
                    paths={[]}
                />
            </Stack.Item>
            <LoginInfo />
        </Stack>
    );
}

export default AppNavigation;
